<div class="basin-content-window basin-scroll-container-vertical">
  <div class="p-grid">
    <div class="p-col-12">
      <div class="basin-display-flex basin-mb-6">
        <div class="basin-display-flex basin-align-items-center">
          <h4>Usage Results</h4>
        </div>
      </div>
      <div class="basin-mb-6">
        <div
          class="p-d-flex p-flex-wrap basin-gap-3 basin-mb-4 basin-width-100"
          style="gap: 1rem"
        >
          <div
            *ngFor="let status of (statusSummary$ | async) || []"
            class="p-d-flex"
            style="flex: 1 1 240px; max-width: 100%"
          >
            <p-card class="basin-width-100">
              <div class="p-d-flex p-ai-center p-jc-between">
                <div class="p-d-flex p-ai-center">
                  <basin-tag
                    [value]="GetStatusDisplay(status.status).label"
                    [theme]="GetStatusDisplay(status.status).theme"
                    [icon]="GetStatusDisplay(status.status).icon"
                  ></basin-tag>
                </div>
                <div class="basin-font-size-xl basin-font-weight-bold">
                  {{ status.count }}
                </div>
              </div>
            </p-card>
          </div>
        </div>

        <p-card>
          <ng-container *ngTemplateOutlet="table"></ng-container>
        </p-card>
      </div>
    </div>
  </div>
</div>

<ng-template #table>
  <p-table
    styleClass="basin-table-height p-datatable-sm"
    withUnsort
    [value]="(usageReport$ | async) || []"
    [paginator]="true"
    [rows]="rows"
    [scrollable]="true"
    responsiveLayout="scroll"
    [rowsPerPageOptions]="paginatorDropdownOptions"
    currentPageReportTemplate="{first} - {last} of {totalRecords}"
    [showCurrentPageReport]="true"
    [globalFilterFields]="['emailAddress', 'userName']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="emailAddress" scope="col">
          <div class="p-d-flex p-ai-center">
            Email
            <p-sortIcon field="emailAddress"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="emailAddress"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="userName" scope="col">
          <div class="p-d-flex p-ai-center">
            User Name
            <p-sortIcon field="userName"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="userName"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="simulationCount" scope="col">
          <div class="p-d-flex p-ai-center">
            Simulations
            <p-sortIcon field="simulationCount"></p-sortIcon>
            <p-columnFilter
              type="numeric"
              field="simulationCount"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="scenarioCount" scope="col">
          <div class="p-d-flex p-ai-center">
            Scenarios
            <p-sortIcon field="scenarioCount"></p-sortIcon>
            <p-columnFilter
              type="numeric"
              field="scenarioCount"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="totalIterations" scope="col">
          <div class="p-d-flex p-ai-center">
            Total Iterations
            <p-sortIcon field="totalIterations"></p-sortIcon>
            <p-columnFilter
              type="numeric"
              field="totalIterations"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.emailAddress }}</td>
        <td>{{ row.userName || "—" }}</td>
        <td>{{ row.simulationCount }}</td>
        <td>{{ row.scenarioCount }}</td>
        <td>{{ row.totalIterations }}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
